import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const brandWidget = {
  createBrandWidget: lazyModuleMethod(
    () => import('./createBrandWidget'),
    'default'
  ),
  updateBrandWidget: lazyModuleMethod(
    () => import('./updateBrandWidget'),
    'default'
  ),
}
